$(document).ready(function () {
    // Re-initialize stars selection logic for the modal forms
    $(document).on('change', '.product-review-form__rating-input', function () {
        const $container = $(this).closest('.product-review-form__rating-stars');
        const val = $(this).val();
        $container.find('.product-review-form__rating-star').removeClass('active');
        $(this).next('.product-review-form__rating-star').addClass('active');
    });

    const loadPreviewImage = function (input, $container) {
        const $uploadText = $container.find('.image-upload__text');
        const maxFiles = $(input).data('max-files');
        const filesAmount = input.files.length;

        if (maxFiles) {
            if (filesAmount >= maxFiles) {
                $uploadText.closest('.image-upload__uploader-container').addClass('d-none');
            } else {
                $uploadText.closest('.image-upload__uploader-container').removeClass('d-none');
            }
            $uploadText.text(filesAmount + '/' + maxFiles);
        } else {
            $uploadText.text(filesAmount);
        }

        const viewerList = $container.find('.image-viewer__list');
        const $template = $container.find('script[type="text/x-custom-template"]').html();

        viewerList.find('.image-viewer__item').remove();

        if (filesAmount) {
            for (let i = filesAmount - 1; i >= 0; i--) {
                viewerList.prepend($template.replace('__id__', i));
            }
            for (let j = filesAmount - 1; j >= 0; j--) {
                let reader = new FileReader();
                reader.onload = function (event) {
                    viewerList
                        .find('.image-viewer__item[data-id=' + j + ']')
                        .find('img')
                        .attr('src', event.target.result);
                };
                reader.readAsDataURL(input.files[j]);
            }
        }
    };

    $(document).on('change', '.image-upload__file-input', function (event) {
        event.preventDefault();

        const $input = $(this);
        const $container = $input.closest('.product-review-form__field--image-upload');
        const maxSize = $input.data('max-size');

        const $form = $input.closest('form');
        if (!$form.data('images-buffer')) {
            $form.data('images-buffer', []);
        }
        let formBuffer = $form.data('images-buffer');

        Array.from(this.files).forEach((file) => {
            if (maxSize && file.size / 1024 > maxSize) {
                const message = $input
                    .data('max-size-message')
                    .replace('__attribute__', file.name)
                    .replace('__max__', maxSize);
                if (typeof Theme !== 'undefined') Theme.showError(message);
            } else {
                formBuffer.push(file);
            }
        });

        const filesAmount = formBuffer.length;
        const maxFiles = $input.data('max-files');
        if (maxFiles && filesAmount > maxFiles) {
            formBuffer.splice(filesAmount - maxFiles - 1, filesAmount - maxFiles);
        }

        const dT = new ClipboardEvent('').clipboardData || new DataTransfer();
        for (let file of formBuffer) {
            dT.items.add(file);
        }
        this.files = dT.files;
        loadPreviewImage(this, $container);
    });

    $(document).on('click', '.image-viewer__icon-remove', function (event) {
        event.preventDefault();
        const $this = $(event.currentTarget);
        const $container = $this.closest('.product-review-form__field--image-upload');
        const $item = $this.closest('.image-viewer__item');
        let id = $item.data('id');
        const $form = $this.closest('form');
        let formBuffer = $form.data('images-buffer') || [];

        formBuffer.splice(id, 1);

        const input = $container.find('input[type=file]')[0];
        const dT = new ClipboardEvent('').clipboardData || new DataTransfer();
        for (let file of formBuffer) {
            dT.items.add(file);
        }
        input.files = dT.files;
        loadPreviewImage(input, $container);
    });

    $(document).off('submit', '.product-review-container-inner .product-review-form').on('submit', '.product-review-container-inner .product-review-form', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const $form = $(this);
        const $button = $form.find('button[type="submit"]');

        if ($button.hasClass('loading')) {
            return;
        }
        const formData = new FormData(this);

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function () {
                $button.prop('disabled', true).addClass('loading');
            },
            success: function (res) {
                if (!res.error) {
                    if (typeof Theme !== 'undefined') Theme.showSuccess(res.message);

                    const $modal = $form.closest('.modal');
                    const $container = $form.closest('.product-review-container-inner');

                    let starsHtml = res.data.stars_html;

                    let imagesHtml = '';
                    if (res.data.images && res.data.images.length > 0) {
                        imagesHtml = '<div class="image-viewer__list d-flex flex-wrap gap-2 mb-2">';
                        res.data.images.forEach(img => {
                            let imgUrl = img;
                            if (!img.startsWith('http')) {
                                imgUrl = '/storage/' + img;
                            }
                            imagesHtml += `<div class="image-viewer__item"><img src="${imgUrl}" width="60" height="60" class="rounded object-fit-cover"></div>`;
                        });
                        imagesHtml += '</div>';
                    }

                    const deleteUrl = '/review/delete/' + res.data.id;
                    const csrfToken = $form.find('input[name="_token"]').val();

                    const existingReviewHtml = `
                        <div class="existing-review-container p-3 rounded bg-light border">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <div class="d-flex align-items-center">
                                    ${starsHtml || ''}
                                </div>
                                <span class="text-muted small">${(res.data && res.data.created_at) ? res.data.created_at : ''}</span>
                            </div>
                            <p class="mb-2 text-dark">${(res.data && res.data.comment) ? res.data.comment : ''}</p>
                            ${imagesHtml || ''}
                            <div class="text-end mt-2">
                                <form action="${deleteUrl}" method="POST" class="d-inline delete-review-form">
                                    <input type="hidden" name="_token" value="${csrfToken}">
                                    <input type="hidden" name="_method" value="DELETE">
                                    <button type="submit" class="btn btn-link text-danger p-0 border-0 text-decoration-none small">
                                        <i class="ti ti-trash me-1"></i>Delete Review
                                    </button>
                                </form>
                            </div>
                        </div>
                    `;

                    $container.html(existingReviewHtml);

                    // Mark that something was changed in this modal
                    $modal.addClass('has-changes');

                    // Re-trigger lightGallery if there are images
                    if (res.data.images && res.data.images.length > 0 && typeof $.fn.lightGallery !== 'undefined') {
                        $container.find('.image-viewer__list').lightGallery({
                            thumbnail: true,
                            selector: '.image-viewer__item img'
                        });
                    }

                    if ($modal.find('.product-review-form').length === 0 && $modal.find('.delete-review-form').length === 0) {
                        setTimeout(() => {
                            $modal.modal('hide');
                            window.location.reload();
                        }, 2000);
                    } else {
                        // Notify user that they can continue reviewing or reload to see full changes
                    }
                } else {
                    if (typeof Theme !== 'undefined') Theme.showError(res.message);
                }
            },
            error: function (xhr) {
                if (typeof Theme !== 'undefined') Theme.handleError(xhr);
            },
            complete: function () {
                $button.prop('disabled', false).removeClass('loading');
            }
        });
    });

    $(document).off('submit', '.delete-review-form').on('submit', '.delete-review-form', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const $form = $(this);
        const $button = $form.find('button[type="submit"]');

        if ($button.hasClass('loading')) {
            return;
        }

        if (!confirm(window.trans && window.trans.confirm_delete ? window.trans.confirm_delete : 'Are you sure you want to delete this review?')) {
            return;
        }

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: $form.serialize(),
            beforeSend: function () {
                $button.prop('disabled', true).addClass('loading');
            },
            success: function (res) {
                if (!res.error) {
                    if (typeof Theme !== 'undefined') Theme.showSuccess(res.message);

                    const $container = $form.closest('.product-review-container-inner');
                    const $reviewItem = $form.closest('.review-product-item');
                    const $modal = $form.closest('.modal');

                    // Show a message instead of just deleting
                    $container.empty().append(`<div class="alert alert-success mt-2 mb-0" style="padding: 10px; border-radius: 5px;">${res.message || 'Deleted successfully'}</div>`);

                    // Mark that something was changed in this modal
                    $modal.addClass('has-changes');

                    if ($modal.find('.product-review-form').length === 0 && $modal.find('.delete-review-form').length === 0) {
                        setTimeout(() => {
                            $modal.modal('hide');
                            window.location.reload();
                        }, 1000);
                    }
                } else {
                    if (typeof Theme !== 'undefined') Theme.showError(res.message);
                }
            },
            error: function (xhr) {
                if (typeof Theme !== 'undefined') Theme.handleError(xhr);
            },
            complete: function () {
                $button.prop('disabled', false).removeClass('loading');
            }
        });
    });
    // Clear some cache when modal is hidden to ensure fresh start next time
    $(document).on('hidden.bs.modal', '.modal', function () {
        if ($(this).hasClass('has-changes')) {
            window.location.reload();
        }
    });
});
